import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import Form from "ui/elements/form/Form";

/**
 * @typedef {object} T_RotateSetupResult
 * @property {number} angleFrom
 * @property {number} angleTo
 */

export default class RotateSetup extends Dialog {
	/**
	 * @param {boolean} [rangeMode]
	 */
	constructor(rangeMode = false) {
		super({
			title: i18n('title.rotate-setup'),
			buttons: [
				{
					caption: i18n('buttons.apply'),
					role: 'apply',
					icon: '/images/icons.svg#icon-svg-check'
				},
				{
					caption: i18n('buttons.close'),
					role: 'close'
				}
			]
		});

		this._rangeMode = rangeMode;

		/**
		 * @type {Form}
		 * @private
		 */
		this._form = null;

		/**
		 * @type {?function(res:T_RotateSetupResult|null)}
		 * @private
		 */
		this._onComplete = null;

		void this._buildForm();
	}

	/**
	 * @returns {Promise<T_RotateSetupResult|null>}
	 */
	getResultPromise() {
		return new Promise((resolve) => {
			this._onComplete = resolve;
		});
	}

	/**
	 * @override
	 * @param {string} role
	 * @returns {void}
	 * @protected
	 */
	_handleButton(role) {
		super._handleButton(role);
		if (role === 'apply') {
			let data = this._form.getValues();
			if (data !== null) {
				this._apply(data);
			}
		}
	}

	/**
	 * @private
	 * @param {Object} data
	 * @returns {void}
	 */
	_apply(data) {
		if (this._onComplete) {
			this._onComplete({
				angleFrom: parseInt(data.angleFrom),
				angleTo: parseInt(this._rangeMode ? data.angleTo : data.angleFrom)
			});
			this._onComplete = null;
			this.destroy();
		}
	}

	/**
	 * @private
	 * @returns {Promise<void>}
	 */
	async _buildForm() {
		let el = document.createElement('div');
		this._form = new Form({
			parent: el,
			onApply: this._apply.bind(this),
			values: {angleFrom: 0, angleTo: 0},
			fields: [
				{
					type: 'angle360',
					name: 'angleFrom',
					min: 0,
					max: 360,
					step: 1,
					caption: i18n(this._rangeMode ? 'inputs.layer.angle-from' : 'inputs.layer.angle'),
				},
				{
					type: this._rangeMode ? 'angle360' : 'hidden',
					name: 'angleTo',
					min: 0,
					max: 360,
					step: 1,
					caption: i18n('inputs.layer.angle-to'),
				},
			]
		});
		this.setContent(el);
	}

	/**
	 * @returns {void}
	 */
	destroy() {
		if (this._onComplete !== null) {
			this._onComplete(null);
			this._onComplete = null;
		}
		super.destroy();
	}
}
